import { feelLight } from '@bpmn-io/cm-theme';
import { EditorView } from '@codemirror/view';

export const baseTheme = EditorView.theme({
  '&': {
    height: '100%',
    width: '100%'
  },
  '.cm-scroller': {
    overflow: 'auto'
  },
  '& .cm-content': {
    padding: '0px',
  },
  '& .cm-line': {
    padding: '0px',
  },
  '&.cm-editor.cm-focused': {
    outline: 'none',
  },
  '& .cm-completionInfo': {
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  '&.cm-editor': {
    height: '100%',
  },

  // Don't wrap whitespace for custom HTML
  '& .cm-completionInfo > *': {
    whiteSpace: 'normal'
  },
  '& .cm-completionInfo ul': {
    margin: 0,
    paddingLeft: '15px'
  },
  '& .cm-completionInfo pre': {
    marginBottom: 0,
    whiteSpace: 'pre-wrap'
  },
  '& .cm-completionInfo p': {
    marginTop: 0,
  },
  '& .cm-completionInfo p:not(:last-of-type)': {
    marginBottom: 0,
  },
  '& .cm-completionDetail': {
    float: 'right',
    fontStyle: 'normal',
  }
});

export default [ baseTheme, feelLight ];